import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "statistic-card" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"display":"inline-flex","align-items":"center"} }, " 目前竞投积分 ", -1)
const _hoisted_4 = { class: "statistic-card" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { style: {"display":"inline-flex","align-items":"center"} }, " 参与人数 ", -1)
const _hoisted_6 = { class: "statistic-card" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { style: {"display":"inline-flex","align-items":"center"} }, " 开始时间 ", -1)
const _hoisted_8 = { class: "statistic-card" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { style: {"display":"inline-flex","align-items":"center"} }, " 剩余时间 ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "search-box" }, "竞投列表", -1)
const _hoisted_11 = { class: "pagestyle" }
const _hoisted_12 = { class: "dialog-footer" }

import { reactive, onMounted, ref} from 'vue'
  import { ElMessage, ElLoading } from 'element-plus'
  import dayjs from 'dayjs'
  import api from '@/api/index'
  
export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

  const value2 = ref(dayjs().add(1, 'month').startOf('month'))
  const searchForm = reactive({
    limit:10,
    page:1,
  })
  const baseData = reactive({
    loading:false,
    title:'',
    biddingbox:false,
  })
  const tableData:any = reactive({
    data:[],
    total:0,
  })
  const biddingform = reactive({
    id:'',
    startTime:'',
    stopTime:'',
    pushTime:'',
    endTime:'',
    leastPoint:100,
    targetPoint: 0,
    status: "true",
  })
  const addshow = () => {
    baseData.biddingbox = true
    biddingform.id = ''
    biddingform.startTime = ''
    biddingform.stopTime = ''
    biddingform.pushTime = ''
    biddingform.endTime = ''
    biddingform.leastPoint = 100
    biddingform.targetPoint = 0
    biddingform.status = "true"
  }
  const add = () => {
    baseData.loading = true
    api.biddingApi.add(biddingform).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        baseData.biddingbox = false
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const handleSizeChange = (val:number) => {
    searchForm.limit = val
    searchForm.page = 1
    getList()
  }
  const handleCurrentChange = (val:any) => {
    searchForm.page = val
    getList()
  }
  const getList = () => {
    baseData.loading = true
    api.biddingApi.list(searchForm).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        for(var i in res.data.list){
          res.data.list[i].status = res.data.list[i].status==1?true:false
        }
        tableData.data = res.data.list
        tableData.total = res.data.total
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const getNowBidding = () => {
    api.biddingApi.getNowBidding().then((res:any)=>{
      if(res.code==200){
        console.log(res.data)
      }else{
        baseData.title = '暂无'
      }
    })
  }
  const changeStatus = (id:number,status:number) => {
    baseData.loading = true
    api.biddingApi.changeStatus({id:id,status:status}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const del = (id:number) => {
    baseData.loading = true
    api.biddingApi.del({id:id}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  onMounted(() => {
    getList()
    getNowBidding()
  })
  
return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_statistic = _resolveComponent("el-statistic")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_countdown = _resolveComponent("el-countdown")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, { shadow: "never" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_breadcrumb, {
            class: "breadcrumb",
            separator: "/"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
                default: _withCtx(() => [
                  _createTextVNode("工作台")
                ]),
                _: 1
              }),
              _createVNode(_component_el_breadcrumb_item, null, {
                default: _withCtx(() => [
                  _createTextVNode("竞投广告")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            class: "editbtn",
            onClick: addshow
          }, {
            default: _withCtx(() => [
              _createTextVNode("创建竞投")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"20px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: 16 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_el_statistic, { value: 98500 }, {
                    title: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_el_statistic, { value: 693700 }, {
                    title: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_el_statistic, { value: 693700 }, {
                    title: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_el_countdown, {
                    format: "DD [days] HH:mm:ss",
                    value: value2.value
                  }, {
                    title: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }, 8, ["value"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"20px"}
    }, {
      default: _withCtx(() => [
        _hoisted_10,
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          "row-key": "id",
          border: "",
          data: tableData.data,
          style: {"width":"100%","margin-top":"10px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "id",
              label: "ID",
              width: "60"
            }),
            _createVNode(_component_el_table_column, {
              prop: "company",
              label: "中标公司"
            }),
            _createVNode(_component_el_table_column, {
              prop: "point",
              label: "目前积分",
              width: "100"
            }),
            _createVNode(_component_el_table_column, {
              prop: "leastPoint",
              label: "最低竞投积分",
              width: "110"
            }),
            _createVNode(_component_el_table_column, {
              prop: "targetPoint",
              label: "目标积分",
              width: "100"
            }),
            _createVNode(_component_el_table_column, {
              prop: "remark",
              label: "备注"
            }),
            _createVNode(_component_el_table_column, {
              prop: "startTime",
              label: "开始时间",
              width: "180"
            }),
            _createVNode(_component_el_table_column, {
              prop: "stopTime",
              label: "截至投票时间",
              width: "180"
            }),
            _createVNode(_component_el_table_column, {
              prop: "pushTime",
              label: "公布时间",
              width: "180"
            }),
            _createVNode(_component_el_table_column, {
              prop: "endTime",
              label: "结束时间",
              width: "200"
            }),
            _createVNode(_component_el_table_column, {
              label: "状态",
              width: "100"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_switch, {
                  size: "large",
                  onChange: ($event: any) => (changeStatus(scope.row.id,scope.row.status)),
                  modelValue: scope.row.status,
                  "onUpdate:modelValue": ($event: any) => ((scope.row.status) = $event),
                  "inline-prompt": "",
                  "active-text": "显示",
                  "inactive-text": "不显示"
                }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              fixed: "right",
              label: "操作",
              width: "140"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_popconfirm, {
                  "confirm-button-text": "Yes",
                  "cancel-button-text": "No",
                  title: "确认是否删除?",
                  onConfirm: ($event: any) => (del(scope.row.id))
                }, {
                  reference: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "danger"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["onConfirm"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, baseData.loading]
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_pagination, {
            "current-page": searchForm.page,
            "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((searchForm.page) = $event)),
            "page-size": searchForm.limit,
            "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((searchForm.limit) = $event)),
            layout: "sizes, prev, pager, next",
            total: tableData.total,
            onSizeChange: handleSizeChange,
            onCurrentChange: handleCurrentChange
          }, null, 8, ["current-page", "page-size", "total"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: baseData.biddingbox,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((baseData.biddingbox) = $event)),
      title: "添加竞投",
      width: "500"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_el_button, {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (baseData.biddingbox = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: add
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 提交 ")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: biddingform,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "开始时间" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: biddingform.startTime,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((biddingform.startTime) = $event)),
                  type: "datetime",
                  placeholder: "",
                  format: "YYYY-MM-DD HH:mm:ss",
                  "value-format": "YYYY-MM-DD HH:mm:ss"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "截至投票时间" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: biddingform.stopTime,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((biddingform.stopTime) = $event)),
                  type: "datetime",
                  placeholder: "",
                  format: "YYYY-MM-DD HH:mm:ss",
                  "value-format": "YYYY-MM-DD HH:mm:ss"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "公布时间" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: biddingform.pushTime,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((biddingform.pushTime) = $event)),
                  type: "datetime",
                  placeholder: "",
                  format: "YYYY-MM-DD HH:mm:ss",
                  "value-format": "YYYY-MM-DD HH:mm:ss"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "结束时间" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: biddingform.endTime,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((biddingform.endTime) = $event)),
                  type: "datetime",
                  placeholder: "",
                  format: "YYYY-MM-DD HH:mm:ss",
                  "value-format": "YYYY-MM-DD HH:mm:ss"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "最低竞投积分" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: biddingform.leastPoint,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((biddingform.leastPoint) = $event)),
                  min: 1
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "目标积分" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: biddingform.targetPoint,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((biddingform.targetPoint) = $event)),
                  min: 1
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  size: "large",
                  modelValue: biddingform.status,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((biddingform.status) = $event)),
                  "inline-prompt": "",
                  "active-text": "显示",
                  "inactive-text": "不显示"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})